export default [
  {
    path: '/app/purchase-offers',
    name: 'PurchaseOffers',
    component: () => import('@/views/Admin/Purchase_offers/Index.vue'),
    meta: {
      pageTitle: 'Satın Alma',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_PURCHASE_OFFERS',
      action: 'read',
    },
  },
  {
    path: '/app/purchase-offers/add',
    name: 'PurchaseOfferAdd',
    component: () => import('@/views/Admin/Purchase_offers/Add.vue'),
    meta: {
      pageTitle: 'Satın Alma',
      breadcrumb: [
        {
          to: '/app/purchase-offers',
          text: 'Liste',
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_PURCHASE_OFFER_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/purchase-offers/edit/:id',
    name: 'PurchaseOfferEdit',
    component: () => import('@/views/Admin/Purchase_offers/Edit.vue'),
    meta: {
      pageTitle: 'Satın Alma',
      breadcrumb: [
        {
          to: '/app/purchase-offers',
          text: 'Liste',
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PURCHASE_OFFER_EDIT',
      action: 'read',
    },
  },
  {
    path: '/app/purchase-offers/view/:id',
    name: 'PurchaseOfferView',
    component: () => import('@/views/Admin/Purchase_offers/View.vue'),
    meta: {
      pageTitle: 'Satın Alma',
      breadcrumb: [
        {
          to: '/app/purchase-offers',
          text: 'Liste',
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'ADMIN_PURCHASE_OFFER_VIEW',
      action: 'read',
    },
  },

]
